import React, { useState } from 'react';
import PlanCard from './PlanCard';
import { Button } from 'day8-ui';
import { FaMinus } from "@react-icons/all-files/fa6/FaMinus";
import { FaPlus } from "@react-icons/all-files/fa6/FaPlus";
import { useSelector } from 'react-redux';
var PlansList = function (_a) {
    var plans = _a.plans, title = _a.title;
    var loggedUser = useSelector(function (state) { return state.user.loggedUser; });
    var _b = useState(false), showAll = _b[0], setShowAll = _b[1];
    var plansToShow = showAll || plans.length <= 3 ? plans : plans.slice(0, 3);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'dui-flex dui-justify-between dui-items-end dui-mb-4' },
            React.createElement("div", null,
                React.createElement("h2", { className: 'dui-font-body dui-text-xl' }, title)),
            React.createElement("div", { className: '' },
                React.createElement(Button, { onClick: function () { return setShowAll(!showAll); }, buttonType: 'LINK', rightIcon: showAll ? React.createElement(FaMinus, null) : React.createElement(FaPlus, null) }, showAll ? 'Show less' : "Show all (".concat(plans.length, ")")))),
        React.createElement("div", { className: "dui-grid dui-grid-cols-1 sm:dui-grid-cols-2 lg:dui-grid-cols-3 dui-gap-8" }, plansToShow.map(function (plan) { return (React.createElement(PlanCard, { key: plan.id, plan: plan, user: loggedUser })); }))));
};
export default PlansList;
